import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import globalContext from '../../../config/context';
import useHook from '../Pendataan/pendataan.hooks';
import './style.css';

//material core
import Button from '@material-ui/core/Button';
import {grey} from '@material-ui/core/colors';

import Dialog from '@material-ui/core/Dialog/Dialog';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import {Card, CardContent, Grid, Typography} from '@material-ui/core';
import {Bar, Line} from 'react-chartjs-2';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  //button
  button: {
    // position: 'absolute',
    bottom: 30,
    right: 115,
    borderRadius: 7,
  },

  //legend content
  box: {
    width: '100vw',
    // padding: '2vh',
    // height: 290,
    // display:'block',
    position: 'absolute',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //options
  options: {
    position: 'relative',
    padding: 20,
    backgroundColor: '#fafafa',
    textAlign: 'left',
  },
  gridCaption: {
    position: 'absolute',
    bottom: 20,
  },
  caption: {
    fontSize: 18,
    fontWeight: 500,
  },
  gridComboBox: {
    marginLeft: 90,
  },
  comboBox: {
    width: '100%',
    disabled: 'true',
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  label: {
    // fontSize: 13,
    textTransform: 'capitalize',
  },
}))(Button);

const PendataanSurveyor = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{checkedPendataan}] = useAppContext();
  const [{kinerjaSurveyor}] = useHook(props);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const data = {
    labels: kinerjaSurveyor.map((o) => o.user_pelayanan),
    datasets: [
      {
        label: 'Objek Baru',
        data: kinerjaSurveyor.map((o) => o.objek_baru),
        backgroundColor: '#179d00',
      },
      {
        label: 'Objek Update',
        data: kinerjaSurveyor.map((o) => o.objek_update),
        backgroundColor: '#ecfc00',
      },
      {
        label: 'Objek Hapus',
        data: kinerjaSurveyor.map((o) => o.objek_hapus),
        backgroundColor: '#CA0617',
      },
      {
        label: 'Objek Pecah Induk',
        data: kinerjaSurveyor.map((o) => o.objek_pecah_induk),
        backgroundColor: '#20B2AA',
      },
      {
        label: 'Objek Pecah Baru',
        data: kinerjaSurveyor.map((o) => o.objek_pecah_baru),
        backgroundColor: '#9932CC',
      },
      {
        label: 'Objek Gabung Induk',
        data: kinerjaSurveyor.map((o) => o.objek_gabung_induk),
        backgroundColor: '#4169E1',
      },
      {
        label: 'Objek Gabung Hapus',
        data: kinerjaSurveyor.map((o) => o.objek_gabung_hapus),
        backgroundColor: '#9c4f1f',
      },
    ],
  };

  let options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };

  return (
    <div>
      <ColorButton
        variant="contained"
        color="default"
        size="small"
        className={classes.button}
        startIcon={<TrackChangesIcon />}
        onClick={handleClickOpen}>
        Surveyor
      </ColorButton>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <PerfectScrollbar>
          <DialogContent style={{backgroundColor: '#efeff1'}}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" style={{textAlign: 'center', marginBottom: 10}}>
                      Data Surveyor
                    </Typography>
                    <Bar data={data} options={options} />
                  </CardContent>
                </Card>
                <TableContainer component={Paper} style={{marginTop: 15}}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>User</TableCell>
                        <TableCell align="right">Objek Baru</TableCell>
                        <TableCell align="right">Objek Update</TableCell>
                        <TableCell align="right">Objek Hapus</TableCell>
                        <TableCell align="right">Objek Pecah Induk</TableCell>
                        <TableCell align="right">Objek Pecah Baru</TableCell>
                        <TableCell align="right">Objek Gabung Induk</TableCell>
                        <TableCell align="right">Objek Gabung Hapus</TableCell>
                        <TableCell align="right">Jumlah</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {kinerjaSurveyor.map((row) => (
                        <TableRow key={row.user_pelayanan}>
                          <TableCell component="th" scope="row">
                            {row.user_pelayanan}
                          </TableCell>
                          <TableCell align="right">{row.objek_baru}</TableCell>
                          <TableCell align="right">{row.objek_update}</TableCell>
                          <TableCell align="right">{row.objek_hapus}</TableCell>
                          <TableCell align="right">{row.objek_pecah_induk}</TableCell>
                          <TableCell align="right">{row.objek_pecah_baru}</TableCell>
                          <TableCell align="right">{row.objek_gabung_induk}</TableCell>
                          <TableCell align="right">{row.objek_gabung_hapus}</TableCell>
                          <TableCell align="right">{row.jumlah}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
      </Dialog>
    </div>
  );
};
export default PendataanSurveyor;
